// ─── BattleViewer2D – Pure Utility Helpers ──────────────────────────────────

export function resolveText(text: string): string {
  return text.replace(/\{\{[^:}]+:[^:}]+:([^}]+)\}\}/g, '$1');
}

export function getLogStyle(eventType: string | null): { color: string; bold: boolean } {
  if (!eventType) return { color: '#b0b0b0', bold: false };
  if (['kill', 'death', 'kill_exhaustion', 'beast_defeated'].includes(eventType))
    return { color: '#ffd700', bold: true };
  if (
    ['hit', 'crit', 'momentum_hit', 'graze', 'momentum_graze',
     'axe_cleave', 'counter_dagger', 'bleed_tick', 'racial_undead_leech',
    ].includes(eventType)
  ) return { color: '#ff8a8a', bold: false };
  if (
    ['dodge_full', 'dodge_partial', 'block_full', 'block_partial',
     'parry_success', 'parry_partial_success',
    ].includes(eventType)
  ) return { color: '#74c0fc', bold: false };
  if (['surrender', 'collapse', 'hospital_collapse'].includes(eventType))
    return { color: '#f0a050', bold: true };
  if (['battle_won', 'draw'].includes(eventType))
    return { color: '#ffd700', bold: true };
  if (eventType === 'round_header') return { color: '#777', bold: false };
  if (
    eventType.startsWith('reward') ||
    ['levelup', 'guild_levelup', 'guild_max_level', 'title_earned',
     'title_earned_also', 'items_unequipped'].includes(eventType)
  ) return { color: '#888', bold: false };
  if (eventType.startsWith('racial_') || eventType === 'freyas_grace')
    return { color: '#ab52f0', bold: false };
  if (['parry_fail', 'block_fail'].includes(eventType))
    return { color: '#88aacc', bold: false };
  if (['parry_weapon_break', 'parry_partial_weapon_break', 'shield_break'].includes(eventType))
    return { color: '#ffd700', bold: true };
  return { color: '#d0d0d0', bold: false };
}

const RACIAL_FLOAT_LABELS: Record<string, string> = {
  racial_human_roar:         'Rallying Roar!',
  racial_dwarf_enhance:      'Weapon Enhanced!',
  racial_troll_intimidation: 'Intimidation!',
  racial_elf_shout:          'Agility Surge!',
  racial_goblin_dirty:       'Dirty Trick!',
  racial_undead_leech:       'Life Drain!',
  racial_orc_berserk:        'Berserk Rage!',
  freyas_grace:              "Freya's Grace!",
};

export function getRacialFloatLabel(eventType: string): string {
  if (RACIAL_FLOAT_LABELS[eventType]) return RACIAL_FLOAT_LABELS[eventType];
  if (eventType.startsWith('racial_')) {
    return eventType
      .replace('racial_', '')
      .split('_')
      .map(w => w.charAt(0).toUpperCase() + w.slice(1))
      .join(' ') + '!';
  }
  return '';
}

export function lerp(a: number, b: number, t: number): number {
  return a + (b - a) * t;
}

export function easeInOut(t: number): number {
  return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
}

export function clamp(val: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, val));
}

export function teamDisplayName(key: string): string {
  switch (key) {
    case 'teamOne':   return 'Team One';
    case 'teamTwo':   return 'Team Two';
    case 'teamThree': return 'Team Three';
    case 'teamFour':  return 'Team Four';
    default:          return key;
  }
}
